import Cookies from 'js-cookie';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  user: {
    pictures: [],
    profile: {
      country: []
    }
  },
  token: Cookies.get('token'),
  isLoading: false,
  states: null,
  chat: false,
};

export default {
  state,
  getters,
  actions,
  mutations
};
